import fr from 'facet-rest';
import { metaOverrideSet as DefaultStepMetaOverrideSet } from 'Views/Page/Content/Modal/Layouts/DefaultStep';

export default fr.metaOverride({ base: DefaultStepMetaOverrideSet });
